// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"35a5fcea","722":"74d65ba8","726":"164416c1","831":"938324de","905":"97150004","928":"08852b34"}[chunkId] + ".chunk.js";
};